/* unplugin-vue-components disabled */import script from "./TierTemplateSwitch.vue?vue&type=script&lang=ts&setup=true"
export * from "./TierTemplateSwitch.vue?vue&type=script&lang=ts&setup=true"

import "./TierTemplateSwitch.vue?vue&type=style&index=0&id=11ac871d&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11ac871d"]])

export default __exports__